import { render } from "./DonationFooter.vue?vue&type=template&id=4179c9ba&scoped=true"
import script from "./DonationFooter.vue?vue&type=script&lang=js"
export * from "./DonationFooter.vue?vue&type=script&lang=js"

import "./DonationFooter.vue?vue&type=style&index=0&id=4179c9ba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4179c9ba"]])

export default __exports__